export const styles = {
  box: {
    width: '100%',
    height: '91px',
    padding: '24px 40px 24px 60px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
};
